import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { BadgeModule } from 'primeng/badge';
import { DatePipe } from '@angular/common';
import { ISqlJob } from '../jobs/sql-job.interface';
import { IJobActivityAuditLog } from './interfaces/job-activity-audit.interface';
import { JobActivityAuditService } from './job-activity-audit.service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    CardModule,
    BadgeModule,
  ],
  providers: [DatePipe],
  selector: 'job-activity-audit',
  templateUrl: './job-activity-audit.component.html',
  styleUrls: ['./job-activity-audit.component.scss'],
})
export class JobActivityAuditComponent implements OnInit {
  @Input() job: ISqlJob = {} as ISqlJob;

  auditLogs: IJobActivityAuditLog[] = [];
  loading: boolean = false;

  constructor(
    private jobActivityAuditService: JobActivityAuditService,
    private datePipe: DatePipe
  ) { }

  async ngOnInit(): Promise<void> {
    this.loadAuditLogs();
  }


  private loadAuditLogs(): void {
    if (!this.job.scJobId) return;

    this.loading = true;
    this.jobActivityAuditService.getJobActivityAuditLogs(this.job.scJobId).subscribe({
      next: (logs) => {
        this.auditLogs = logs;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading audit logs:', error);
        this.loading = false;
      }
    });
  }

  formatDateTime(date: Date): string {
    return this.datePipe.transform(date, 'short') || '';
  }

  getUserFullName(auditLog: IJobActivityAuditLog): string {
    if (auditLog.UserProfile && auditLog.UserProfile.FirstName && auditLog.UserProfile.LastName) {
      return `${auditLog.UserProfile.FirstName} ${auditLog.UserProfile.LastName}`;
    } else if (auditLog.UserProfile && auditLog.UserProfile.EmailID) {
      return `Email: ${auditLog.UserProfile.EmailID}`;
    }
    //if by any chance the UserProfile is not available, we can fallback to UserID
    return `User ID: ${auditLog.UserID}`;
  }
}
